// extracted by mini-css-extract-plugin
export var LifeDetail = "index-module--LifeDetail--BKumT";
export var maskLayer = "index-module--maskLayer--HfAR2";